import { env } from '@/config/env';
import { normalizeImageSrc } from '@/utils/imageUrl';
import {
    addCommodityBase,
    addFunction,
    addOrganization,
    addOrganizationUser,
    checkMesOrganizationUser,
    checkMesProduct,
    checkProduct,
    addPayCode,
    adIndex,
    adpMacIndex,
    adpMacSelectList,
    allBrandName,
    allCategoryName,
    getProductRfidDetail,
    productRfidDel,
    allWarehouse,
    allWarehouses,
    arehouseIndex,
    authList,
    batchAddingMachines,
    bjDeliveryDetails,
    bjWarehousingDetails,
    brandIndex,
    chaDeliveryDetails,
    chaMachineAdvertisement,
    chaReplenishmentNote,
    chaReplenishmentNoteNew,
    chaWarehousingDetails,
    checkFault,
    checkToken,
    commodity_list,
    commodityBaseIndex,
    confirmDelivery,
    confirmWarehousing,
    contractIndex,
    copyWay,
    daoAdmin,
    daoContract,
    daoDelivery,
    daoDrugUsers,
    daoMachines,
    daoMachineSalesAmountIndex,
    daoMachineType,
    daoOrder,
    daoOrderEmergency,
    daopickupOrder,
    daoProduct,
    daoRefund,
    daoRoad,
    daoSignup,
    daoSubWarehouse,
    daoWarehousing,
    delAd,
    delAdmin,
    delAdPlan,
    delArehouse,
    delBrand,
    delCategory,
    uppic,
    delDelivery,
    delFunction,
    DeliveryIndex,
    delMachineAdvertisement,
    delMachineType,
    delOrganization,
    delOrganizationUser,
    inputbyfirm,
    inputbyupdatedel,
    getAdminByOrder,
    zhipaiOrder,
    getinputby,
    delPayCode,
    delProblem,
    delProduct,
    previewProductDeletion,
    commitProductDeletion,
    delroad,
    delRoadIndex,
    roadSet0,
    delRoadTemplateDetail,
    delRole,
    delStock,
    delWarehousing,
    drugUsersIndex,
    editSome,
    exportOrder,
    fullAllRoad,
    functionList,
    functionListMe,
    generateRoutes,
    getAddAdminAuth,
    getAdminRoleList,
    getAdDetail,
    getAdminDetail,
    getAdPlanDetail,
    getAdPlanList,
    replenishmentTotal,
    getAllProductName,
    getAllProductNameDetail,
    getAllProductNameDetails,
    getAllProductNames,
    getAllUpdateRoadDetail,
    getArehouseDetail,
    getBarDetail,
    getBlinkboxOrderList,
    getBlinkboxOrderWithdrawalList,
    getBrandDetail,
    getCategoryDetail,
    getCommodityBaseDetail,
    getDailyData,
    getDataPerMachine,
    getdetail,
    getMacPipe,
    addMacPipe,
    delMacPipe,
    getMacPipeById,
    copyMacPipe,
    snswap,
    setMachinesTargetVersion,
    fillMacPipe,
    getFunctionDetail,
    getFunctionName,
    getHistoryList,
    getLog,
    machineLogDownload,
    machineLogList,
    machineLogRequest,
    machineRestartList,
    clearMac,
    clearFaceData,
    clearCardData,
    getMachineLicensingUser,
    getMachinesProductDetail,
    getMachinesProductIndex,
    getMacsRoadDetail,
    getNodest,
    getOrganizationDetail,
    getOrganizationUserDetail,
    getOutall,
    getOutStockDetail,
    getPayCodeProductList,
    getProblemDetail,
    getProductDetail,
    getProductMaterialDetail,
    allProductAndCategory,
    itemCodeIndex,
    itemCodeSave,
    itemCodeImport,
    itemCodeFreeze,
    itemCodeTrace,
    itemCodeEvents,
    getRefundDetail,
    getAdminUsers,
    getRoadDetail,
    getRoadMachines,
    getRoadTemplateDetail,
    getRoleDetail,
    getRunSetting,
    getSalesDetails,
    getSignupDetail,
    getStockDetail,
    getTroubleShootingDetail,
    getMaterialDetail,
    getMaterialLists,
    getMaterialCategoryDetail,
    materialDel,
    changeMaterialState,
    changeseparateSettingState,
    separateSettingDel,
    materialCategoryDel,
    saveMaterialTaste,
    recharge,
    getTypeDetail,
    getUpdateRoadDetail,
    getUserInfo,
    getWarehouseDetails,
    handleTrouble,
    historyIndex,
    infoIndex,
    infomationSave,
    inStockIndex,
    jq_addsave,
    login,
    machineAdvertisementIndex,
    machineAdvertisingStatus,
    machineImg,
    machineLicensingOrganization,
    machineLicensingUser,
    machineSalesAmountIndex,
    machineSalesRanking,
    MachinesDay,
    machinesDayTurnover,
    machinesDetail,
    machinesIndex,
    machinesjqcode,
    machinesMonth,
    machinesRoadIndex,
    getBoxList,
    getBoxPackage,
    getRetrunBoxList,
    getRetrunBoxDetail,
    saveReturnExamine,
    orderBoxIndex,
    boxWeightSessionIndex,
    boxWeightSessionReview,
    orderReceiveIndex,
    orderReceiveGoodsIndex,
    getusers,
    daoGrantUserStatements,
    grantUserStatementsIndex,
    salesStatistics,
    salesStatisticsbymac,
    borrowStatementsIndex,
    mac_materialsIndex,
    productalertlog,
    productAlertLogread,
    productAlertLogInsert,
    grantUserStatementsTotalIndex,
    oneUserSalesRanking,
    oneUserBorrowRanking,
    grantMacStatementsIndex,
    grantMacStatementsIndexLite,
    saveBox,
    previewBoxStockTransition,
    commitBoxStockTransition,
    saveBoxPackage,
    saveWholeTakeBox,
    disableBoxPackage,
    prepareBoxPackagePacking,
    openBoxPackagePacking,
    resolveBoxPackagePackingDoor,
    commitBoxPackagePacking,
    cancelBoxPackagePacking,
    getBoxPackagePackingRecords,
    handleBoxPackageItem,
    toOpenBox,
    setRoadUsers,
    machineTypeIndex,
    mergingFreightLanes,
    mobileSave,
    numChangIndex,
    onlineDuration,
    open,
    operatingStatementsIndex,
    orderEmergencyDetail,
    orderEmergencyIndex,
    orderIndex,
    orderLog,
    organizationIndex,
    organizationNameIndex,
    getAllProductIndex,
    getProductBymoid,
    getAllProductIndexNew,
    getProductLathe,
    getOrderLog,
    daoruOrderReceive,
    getAllProductCid,
    outboundOrder,
    outLogin,
    outStockIndex,
    passwordSave,
    payCodeIndex,
    payeeIndex,
    payeeOIndex,
    pickupOrderDetails,
    pickupOrderIndex,
    getLatheList,
    getWsList,
    getUserGroupList,
    getVisibleUserGroupList,
    moveOrganization,
    saveLathe,
    saveWs,
    saveUserGroup,
    pickupOrderDel,
    problemIndex,
    productCategoryIndex,
    productCategoryOid,
    productIndex,
    productMachinesIndex,
    getRoadHis,
    getRoadHisLast,
    getBoxHis,
    productSalesRanking,
    productBorrowRanking,
    pushAd,
    querenMergingFreightLanes,
    RecordDuring,
    RecordDuringDetails,
    refundIndex,
    replenishmentIndex,
    replenishmentNote,
    report_form,
    restart,
    restartApp,
    openDor,
    roadIndex,
    roadTemplateIndex,
    roleIndex,
    runSetting,
    wholeTakePartialReturnSetting,
    saveWholeTakePartialReturnSetting,
    salesTrend,
    saveAd,
    saveAdmin,
    saveAdPlan,
    saveReceive,
    getReceiveDetail,
    saveAdPlanMac,
    saveAisle,
    saveAllRoad,
    saveArehouse,
    saveAuth,
    saveBlinkboxOrderWithdrawal,
    saveBrand,
    saveCategory,
    saveDelivery,
    saveFunction,
    saveMachineAdvertisement,
    saveMachinesDetail,
    saveSubscribeWxGzh,
    getIncenseQrConfig,
    saveIncenseQrConfig,
    savePortionUsers,
    getSubscribeWxGzhList,
    saveMachinesProductDetail,
    saveMachinesRoad,
    saveMachinesNopush,
    saveMachinesBox,
    saveMachineType,
    saveOrganization,
    saveOrganizationUser,
    saveOutStock,
    savePayee,
    savePayeeO,
    saveProblem,
    saveProduct,
    syncProductRoadPrice,
    saveProductDaoRu,
    saveRefund,
    orderEnd,
    orderBoxEnd,
    orderReceiveEnd,
    operationOrderFormMaterial,
    saveRoad,
    saveRoadTemplate,
    saveRoadEpithet,
    saveRole,
    saveStock,
    saveTroubleShooting,
    saveMaterial,
    orderFormMaterialList,
    getOrderFormMaterialDetail,
    separateAccountList,
    getXcxUserList,
    separateSettingList,
    productRfidList,
    saveProductRfid,
    saveSeparateSetting,
    separateDetailsList,
    separateVerifyList,
    saveSeparateAccount,
    getDaPingList,
    separateAccountDel,
    getSeparateSettingDetail,
    getSeparateAccountDetail,
    getSeparateDetailsDetail,
    separateAccountLists,
    saveMaterialCategory,
    saveVersion,
    saveWarehousing,
    saveWx,
    saveWxxcx,
    workflowUser,
    getWorkflowDetail,
    workflowIndex,
    saveWorkflow,
    saveCoupon,
    addCouponIssuance,
    saveSetMeal,
    seek,
    sendSms,
    signupIndex,
    introduce,
    stockIndex,
    subWarehouseIndex,
    troubleShootingIndex,
    material,
    materialCategory,
    getCategoryLists,
    updataStatus,
    updateAllRoadStatus,
    updateMachinesStatus,
    setLockStatus,
    getLockStatus,
    updateReplenishment,
    updateRoadStatus,
    updateStatus,
    uptoken,
    uploadFiles,
    saveHearImg,
    userIndex,
    storageList,
    storageSetup,
    setupSave,
    storageChange,
    versionIndex,
    wxIndex,
    wxxcxIndex,
    couponIndex,
    couponIssuanceIndex,
    setMealIndex
} from "../../api/table";
import {empty, getToken, removeToken} from '@/utils/auth';
import { STORAGE_KEYS } from '@/constants/app';
import {constantRouterMap} from '@/router/routes';
import { log } from '@/utils/logger'
import { clearPersistentToken } from '@/utils/persistentAuth';
import { broadcastLogout, setPasswordLoginToken } from '@/utils/authSync';
import { clearOrgUiConfigCache } from '@/utils/orgUiConfigCache';

function persistHeaderSession(data) {
    if (!data || !data.info) {
        return;
    }
    try {
        sessionStorage.setItem(STORAGE_KEYS.sessionFilesUrl, data.filesUrl || '');
        sessionStorage.setItem(STORAGE_KEYS.sessionUsername, data.info.username || '');
        sessionStorage.setItem(STORAGE_KEYS.sessionHeadimgurl, data.info.headimgurl || '');
        if (data.info.userid != null && data.info.userid !== '') {
            sessionStorage.setItem(STORAGE_KEYS.sessionUserid, String(data.info.userid));
            window.localStorage.setItem('userid', String(data.info.userid));
        }
    } catch (e) {
        // ignore quota / private mode
    }
}

function clearHeaderSession() {
    sessionStorage.removeItem(STORAGE_KEYS.sessionFilesUrl);
    sessionStorage.removeItem(STORAGE_KEYS.sessionUsername);
    sessionStorage.removeItem(STORAGE_KEYS.sessionHeadimgurl);
    sessionStorage.removeItem(STORAGE_KEYS.sessionUserid);
    window.localStorage.removeItem('userid');
}

function persistReplenisherStockOnly(commit, value) {
    if (value === undefined || value === null) {
        return;
    }
    const effectiveValue = Number(value) === 1 ? 1 : 0;
    commit('SET_REPLENISHER_STOCK_ONLY', effectiveValue);
    window.localStorage.setItem('replenisher_stock_only', String(effectiveValue));
}

function clearReplenisherStockOnlySession(commit) {
    commit('SET_AUTHID', null);
    commit('SET_REPLENISHER_STOCK_ONLY', 0);
    window.localStorage.removeItem('replenisher_stock_only');
    window.localStorage.removeItem('authid');
}


const table = {
    state: {
        token: getToken(), // 客户端记号
        tabledata: [], // 树形列表
        commlist: [], // 购物车列表
        routerLoading: false, //路由的loading过渡
        routers: constantRouterMap, //路由表 用于生成左侧菜单
        addRouters: [], //获取到的路由
        username: "", // 用户昵称
        headimgurl: "", // 用户头像
        filesUrl: env.BASE_OSS,//文件路径（本地，阿里云等）
        moid: "", // 超级总机构id
        userid: null, // 用户id
        authid: Number(window.localStorage.getItem("authid")) || null, // 用户权限
        replenisherStockOnly: Number(window.localStorage.getItem("replenisher_stock_only")) === 1 ? 1 : 0,
        mobile: "", // 用户手机
        oid: null, // 最大组织id
        organname: "",
        xparentid: null,
        role: [], // 用户所有类型
        no_role: [], // 用户编辑类型
        institut: [], // 组织机构
        lements: [], // 货道类型
        machiname: "", // 机器型号名称
        machinesname: "", // 机器名称
        jiqicode: "", // 机器编号
        create_time: "", /// 补货时间
        nums: "", // 数量
        lang: "",//语言
        orgUiConfig: null, // 超级总机构 UI 配置
    },
    mutations: {
        SET_lang(state, lang) {
            state.lang = lang
        },
        // 补货详情
        SET_machinesname(state, machinesname) {
            state.machinesname = machinesname
        },
        SET_jiqicode(state, jiqicode) {
            state.jiqicode = jiqicode
        },
        SET_create_time(state, create_time) {
            state.create_time = create_time
        },
        SET_nums(state, nums) {
            state.nums = nums
        },
        //修改路由loading状态
        UPDATE_ROUTER_LOADING(state, status) {
            state.routerLoading = status
        },
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers;
            state.routers = constantRouterMap.concat(routers);
        },
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_TABLEDATA(state, tabledata) {
            state.tabledata = tabledata;
        },
        SET_COMMLIST(state, commlist) {
            state.commlist = commlist;
        },
        SET_USERNAME(state, username) {
            state.username = username
        },
        SET_MOBILE(state, mobile) {
            state.mobile = mobile
        },
        SET_HEADIMGURL(state, headimgurl) {
            if (empty(headimgurl)) {
                state.headimgurl = normalizeImageSrc(env.BASE_LOGO, env.BASE_OSS)
            } else
                state.headimgurl = headimgurl
        },
        SET_FILESURL(state, filesUrl) {
            if (empty(filesUrl)) {
                state.filesUrl = env.BASE_OSS
            } else
                state.filesUrl = filesUrl
        },
        
        SET_USERID(state, userid) {
            state.userid = userid
        },
        SET_MOID(state, moid) {
            state.moid = moid
        },
        SET_ORGANI_ID(state, oid) {
            state.oid = oid
        },
        SET_ORGANNAME(state, organname) {
            state.organname = organname
        },
        SET_PARENTID(state, xparentid) {
            state.xparentid = xparentid
        },
        SET_ROLE(state, role) {
            state.role = role
        },
        SET_NO_ROLE(state, no_role) {
            state.no_role = no_role
        },
        SET_INSTITUT(state, institut) {
            state.institut = institut
        },
        SET_AUTHID(state, authid) {
            state.authid = authid
        },
        SET_REPLENISHER_STOCK_ONLY(state, value) {
            state.replenisherStockOnly = Number(value) === 1 ? 1 : 0
        },
        SET_LEMENTS(state, lements) {
            state.lements = lements
        },
        SET_MACHINAME(state, machiname) {
            state.machiname = machiname
        },
        SET_ORG_UI_CONFIG(state, config) {
            state.orgUiConfig = config
        },
    },
    actions: {
        changeFilesUrl({ commit }, data) {
            commit('SET_FILESURL', data)
        },
        RestoreHeaderSession({ commit, state }) {
            if (empty(getToken())) {
                return Promise.resolve();
            }
            const filesUrl = sessionStorage.getItem(STORAGE_KEYS.sessionFilesUrl);
            const username = sessionStorage.getItem(STORAGE_KEYS.sessionUsername);
            const headimgurl = sessionStorage.getItem(STORAGE_KEYS.sessionHeadimgurl);
            if (!empty(filesUrl) && empty(state.filesUrl)) {
                commit('SET_FILESURL', filesUrl);
            }
            if (!empty(username) && empty(state.username)) {
                commit('SET_USERNAME', username);
            }
            if (headimgurl !== null && empty(state.headimgurl)) {
                commit('SET_HEADIMGURL', headimgurl);
            }
            if (state.userid == null || state.userid === '') {
                const sessionUserid = sessionStorage.getItem(STORAGE_KEYS.sessionUserid);
                const localUserid = window.localStorage.getItem('userid');
                const userid = sessionUserid || localUserid;
                if (!empty(userid)) {
                    commit('SET_USERID', Number(userid) || userid);
                }
            }
            if (state.userid != null && state.userid !== '') {
                return Promise.resolve();
            }
            return infoIndex().then((data) => {
                const uid = data?.info?.userid;
                if (uid == null || uid === '') {
                    return;
                }
                commit('SET_USERID', uid);
                try {
                    sessionStorage.setItem(STORAGE_KEYS.sessionUserid, String(uid));
                    window.localStorage.setItem('userid', String(uid));
                } catch (e) {
                    // ignore quota / private mode
                }
            }).catch(() => {});
        },
        /**
         * 测试动态路由
         */
        GenerateRoutes({
                           commit,
                           state
                       }) {
            return new Promise(resolve => {
                generateRoutes().then(data => {
                    commit('SET_ROUTERS', data);
                    resolve(data);
                })
            })
        },
        // // 获取用户信息动态生成路由
        // Test({
        //     commit,
        //     state
        // }) {
        //     return new Promise((resolve, reject) => {
        //         test().then(data => {
        //             resolve(data);
        //         }).catch(error => {
        //             reject(error);
        //         })
        //     })
        // },
        // 获取表格数据
        GetUserInfo({
                        commit,
                        state
                    }) {
            return new Promise((resolve, reject) => {
                getUserInfo().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 获取树形列表
        GetNodest({
                      commit,
                      state
                  }) {
            return new Promise((resolve, reject) => {
                getNodest().then(data => {
                    commit("SET_TABLEDATA", data)
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 购物车
        Commodity_List({
                           commit,
                           state
                       }, params) {
            return new Promise((resolve, reject) => {
                commodity_list(params.jqcode).then(data => {
                    commit("SET_COMMLIST", data);
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 物品条件查询
        Seek({
                 commit,
                 state
             }, hunt) {
            return new Promise((resolve, reject) => {
                seek(hunt).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        /**
         * 用户登录
         */
        Login({
                  commit,
                  state
              }, enter) {
            clearOrgUiConfigCache();
            commit('SET_ORG_UI_CONFIG', null);
            return new Promise((resolve, reject) => {
                login(enter).then(data => {
                    commit('SET_TOKEN', data.token);
                    commit('SET_USERNAME', data.info.username);
                    commit('SET_FILESURL', data.filesUrl);
                    setPasswordLoginToken(data.token, data.info.userid);
                    window.localStorage.setItem("isMain", data.info.isMain);
                    window.localStorage.setItem('isStandaloneCustomer', data.info.isStandaloneCustomer ? '1' : '0');
                    window.localStorage.setItem("ismain", data.info.ismain != null ? String(data.info.ismain) : "0");
                    window.localStorage.setItem("macBigTypeIds", data.info.macBigTypeIds);
                    window.localStorage.setItem("oid", data.info.oid);
                    window.localStorage.setItem("moid", data.info.moid);
                    window.localStorage.setItem("lifeunit", data.info.lifeunit);
                    window.localStorage.setItem("isinputlife", data.info.isinputlife);
                    window.localStorage.setItem("ordermark1name", data.info.ordermark1name);
                    window.localStorage.setItem("ordermark2name", data.info.ordermark2name);
                    window.localStorage.setItem("ordermark3name", data.info.ordermark3name);
                    window.localStorage.setItem("odmark1name", data.info.odmark1name);
                    window.localStorage.setItem("odmark2name", data.info.odmark2name);
                    window.localStorage.setItem("odmark3name", data.info.odmark3name);
                    window.localStorage.setItem("outodmark1name", data.info.outodmark1name || "");
                    window.localStorage.setItem("outodmark2name", data.info.outodmark2name || "");
                    window.localStorage.setItem("outodmark3name", data.info.outodmark3name || "");
                    window.localStorage.setItem("rordermark1name", data.info.rordermark1name);
                    window.localStorage.setItem("rordermark2name", data.info.rordermark2name);
                    window.localStorage.setItem("rordermark3name", data.info.rordermark3name);
                    window.localStorage.setItem("rodmark1name", data.info.rodmark1name);
                    window.localStorage.setItem("rodmark2name", data.info.rodmark2name);
                    window.localStorage.setItem("rodmark3name", data.info.rodmark3name);
                    window.localStorage.setItem("bordermark1name", data.info.bordermark1name);
                    window.localStorage.setItem("bordermark2name", data.info.bordermark2name);
                    window.localStorage.setItem("bordermark3name", data.info.bordermark3name);
                    window.localStorage.setItem("brordermark1name", data.info.brordermark1name);
                    window.localStorage.setItem("brordermark2name", data.info.brordermark2name);
                    window.localStorage.setItem("brordermark3name", data.info.brordermark3name);
                    commit('SET_HEADIMGURL', data.info.headimgurl);
                    commit('SET_USERID', data.info.userid);
                    commit('SET_AUTHID', data.info.authid);
                    commit('SET_REPLENISHER_STOCK_ONLY', data.info.replenisher_stock_only);
                    window.localStorage.setItem('authid', data.info.authid);
                    window.localStorage.setItem('replenisher_stock_only', data.info.replenisher_stock_only ? 1 : 0);
                    commit('SET_MOBILE', data.info.mobile);
                    commit('SET_MOID', data.info.moid);
                    persistHeaderSession(data);
                    resolve(data);
                }).catch(error => {
                    log(521);
                    log(error);
                    reject(error);
                })
            })
        },
        /**
         * 用户登出
         */
        OutLogin({
                     commit,
                     state
                 }) {
            return new Promise((resolve, reject) => {
                outLogin().then(data => {
                    commit('SET_TOKEN', null);
                    commit('SET_ORG_UI_CONFIG', null);
                    clearReplenisherStockOnlySession(commit);
                    clearPersistentToken();
                    clearOrgUiConfigCache();
                    removeToken();
                    broadcastLogout();
                    clearHeaderSession();
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 判断用户登录是否过期
        CheckToken({
                       commit,
                       state
                   }) {
            return new Promise((resolve, reject) => {
                checkToken().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 首页数据详情
        Introduce({
                      commit,
                      state
                  }) {
            return new Promise((resolve, reject) => {
                introduce().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 首页图表数据
        Report_form({
                        commit,
                        state
                    }) {
            return new Promise((resolve, reject) => {
                report_form().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        SalesTrend({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                salesTrend(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 机器销售额排名
        MachineSalesRanking({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                machineSalesRanking(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 物品销售额排名
        ProductSalesRanking({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                productSalesRanking(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 用户列表
        UserIndex({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                userIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 用户编辑获取详情
        GetAdminDetail({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                getAdminDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 保存用户编辑
        SaveAdmin({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                saveAdmin(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 删除用户数据
        DelAdmin({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                delAdmin(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 导出机器列表
        DaoAdmin({
                     commit,
                     state
                 }, rows) {
            return new Promise((resolve, reject) => {
                daoAdmin(rows).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        /**
         * 机器列表
         */
        MachinesIndex({
                          commit,
                          state
                      }, signcote) {
            return new Promise((resolve, reject) => {
                machinesIndex(signcote).then(data => {
                    log(597);
                    log(data);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查看今日在线时长
        OnlineDuration({
                           commit,
                           state
                       }, params) {
            return new Promise((resolve, reject) => {
                onlineDuration(params.id).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 查看机器状态
        Open({
                 commit,
                 state
             }, params) {
            return new Promise((resolve, reject) => {
                open(params.id).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        /**
         * 查看图片
         */
        MachineImg({
                       commit,
                       state
                   }, imgid) {
            return new Promise((resolve, reject) => {
                machineImg(imgid).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        /**
         * 操作机器
         */
        Restart({
                    commit,
                    state
                }, OPmace) {
            return new Promise((resolve, reject) => {
                restart(OPmace).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        /**
         * 清空货道
         */
        Delroad({
                    commit,
                    state
                }, aisle) {
            return new Promise((resolve, reject) => {
                delroad(aisle).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        /**
         * 获取编辑货道数据
         */
        Getdetail({
                      commit,
                      state
                  }, compile) {
            return new Promise((resolve, reject) => {
                getdetail(compile).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
         /**
         * 获取机器管道数据
         */
         GetMacPipe({
            commit,
            state
        }, compile) {
        return new Promise((resolve, reject) => {
            getMacPipe(compile).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error)
            })
        })
        },
         /**
         * 新增机器管道数据
         */
         AddMacPipe({
            commit,
            state
        }, compile) {
        return new Promise((resolve, reject) => {
            addMacPipe(compile).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error)
            })
        })
        },
         /**
         * 删除机器管道数据
         */
         DelMacPipe({
            commit,
            state
        }, compile) {
        return new Promise((resolve, reject) => {
            delMacPipe(compile).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error)
            })
        })
        },
            /**
         * 根据ID获取机器管道数据
         */
            DetMacPipeById({
                commit,
                state
            }, compile) {
            return new Promise((resolve, reject) => {
                getMacPipeById(compile).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
            },
        /**
         * 复制机器管道数据
         */
                CopyMacPipe({
                    commit,
                    state
                }, compile) {
                return new Promise((resolve, reject) => {
                    copyMacPipe(compile).then(data => {
                        resolve(data);
                    }).catch(error => {
                        reject(error)
                    })
                })
                },
                 /**
         * sn切换
         */
                 Snswap({
                    commit,
                    state
                }, compile) {
                return new Promise((resolve, reject) => {
                    snswap(compile).then(data => {
                        resolve(data);
                    }).catch(error => {
                        reject(error)
                    })
                })
                },
                SetMachinesTargetVersion({
                    commit,
                    state
                }, compile) {
                return new Promise((resolve, reject) => {
                    setMachinesTargetVersion(compile).then(data => {
                        resolve(data);
                    }).catch(error => {
                        reject(error)
                    })
                })
                },
             /**
             * 一键补满机器通道
              */
                FillMacPipe({
                    commit,
                    state
                }, compile) {
                return new Promise((resolve, reject) => {
                    fillMacPipe(compile).then(data => {
                        resolve(data);
                    }).catch(error => {
                        reject(error)
                    })
                })
                },
        // 导出表格数据
        DaoMachines({
                        commit,
                        state
                    }, rows) {
            return new Promise((resolve, reject) => {
                daoMachines(rows).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 批量导入
        BatchAddingMachines({
                                commit,
                                state
                            }, bodate) {
            return new Promise((resolve, reject) => {
                batchAddingMachines(bodate).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 保存编辑
        jq_addsave({
                       commit,
                       state
                   }, addrest) {
            return new Promise((resolve, reject) => {
                jq_addsave(addrest).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 用户类型列表
        RoleIndex({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                roleIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 编辑用户类型获取详情
        GetRoleDetail({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                getRoleDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存用户类型编辑
        SaveRole({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                saveRole(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除用户类型
        DelRole({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                delRole(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 权限
        AuthList({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                authList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 修改权限
        SaveAuth({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                saveAuth(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 功能列表
        FunctionList({
                         commit,
                         state
                     }) {
            return new Promise((resolve, reject) => {
                functionList().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        FunctionListMe({
                           commit,
                           state
                       }) {
            return new Promise((resolve, reject) => {
                functionListMe().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        GetFunctionDetail({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getFunctionDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存功能列表编辑
        SaveFunction({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                saveFunction(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除列表
        DelFunction({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                delFunction(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetFunctionName({
                            commit,
                            state
                        }) {
            return new Promise((resolve, reject) => {
                getFunctionName().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存新新录功能
        AddFunction({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                addFunction(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 个人中心
        InfoIndex({
                      commit,
                      state
                  }) {
            return new Promise((resolve, reject) => {
                infoIndex().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 用户信息修改
        InfomationSave({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                infomationSave(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 修改用户密码
        PasswordSave({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                passwordSave(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 保存货道备注
        SaveRoadEpithet({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                saveRoadEpithet(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 新录货道模板
        SaveRoadTemplate({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                saveRoadTemplate(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取短信验证码
        SendSms({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                sendSms(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 修改手机号
        MobileSave({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                mobileSave(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 入库列表
        InStockIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                inStockIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        AllWarehouse({
                         commit,
                         state
                     }) {
            return new Promise((resolve, reject) => {
                allWarehouse().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetWarehouseDetails({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                getWarehouseDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetAllProductName({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getAllProductName(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetAllProductNameDetails({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                getAllProductNameDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetAllProductNameDetail({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                getAllProductNameDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        BjDeliveryDetails({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                bjDeliveryDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 确认出库
        ConfirmDelivery({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                confirmDelivery(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出出库单
        DaoDelivery({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                daoDelivery(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存新录仓库
        SaveWarehousing({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                saveWarehousing(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查看入库单
        ChaWarehousingDetails({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                chaWarehousingDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除入库
        DelWarehousing({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                delWarehousing(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 入库单确认
        ConfirmWarehousing({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                confirmWarehousing(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        BjWarehousingDetails({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                bjWarehousingDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 出库列表
        DeliveryIndex({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                DeliveryIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存新录出库单
        SaveDelivery({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                saveDelivery(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        ChaDeliveryDetails({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                chaDeliveryDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除出库单
        DelDelivery({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                delDelivery(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出入库数据
        DaoWarehousing({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                daoWarehousing(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 分仓库库存列表
        SubWarehouseIndex({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                subWarehouseIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出分仓库库存列表
        DaoSubWarehouse({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                daoSubWarehouse(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 机器型号
        MachineTypeIndex({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                machineTypeIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 机器型号编辑 获取详情
        GetTypeDetail({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                getTypeDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveMachineType({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                saveMachineType(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除机器型号数据
        DelMachineType({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                delMachineType(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出机器列表
        DaoMachineType({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                daoMachineType(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 货道列表
        RoadIndex({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                roadIndex(date).then(data => {
                    persistReplenisherStockOnly(commit, data.replenisher_stock_only);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 货道编辑 获取详情
        GetRoadDetail({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                getRoadDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存货道编辑
        SaveRoad({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                saveRoad(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除货道数据
        DelRoadIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                delRoadIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        RoadSet0({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                roadSet0(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取播放计划详情
        GetAdPlanDetail({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                getAdPlanDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveAdPlan({
            commit,
            state
        }, date) {
       return new Promise((resolve, reject) => {
      saveAdPlan(date).then(data => {
         resolve(data);
       }).catch(error => {
         reject(error)
      })
     })
    },
    GetReceiveDetail({
                commit,
                state
            }, date) {
        return new Promise((resolve, reject) => {
            getReceiveDetail(date).then(data => {
            resolve(data);
        }).catch(error => {
            reject(error)
        })
        })
        },
      SaveReceive({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                saveReceive(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SavePayee({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                savePayee(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveWxxcx({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                saveWxxcx(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        GetWorkflowDetail({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getWorkflowDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        WorkflowUser({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                workflowUser(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        WorkflowIndex({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                workflowIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveWorkflow({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                saveWorkflow(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        SaveCoupon({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                saveCoupon(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        AddCouponIssuance({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                addCouponIssuance(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        SaveSetMeal({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                saveSetMeal(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        DelPayCode({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                delPayCode(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        AddPayCode({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                addPayCode(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SavePayeeO({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                savePayeeO(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveVersion({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                saveVersion(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        SaveWx({
                   commit,
                   state
               }, date) {
            return new Promise((resolve, reject) => {
                saveWx(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveAdPlanMac({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                saveAdPlanMac(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        AdpMacSelectList({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                adpMacSelectList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        DelAdPlan({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                delAdPlan(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetRunSetting({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                getRunSetting(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        ProductMachinesIndex({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                productMachinesIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetRoadHis({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                getRoadHis(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetRoadHisLast({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                getRoadHisLast(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetBoxHis({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                getBoxHis(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 导出货道列表
        DaoRoad({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                daoRoad(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 复制货道
        SaveAisle({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                saveAisle(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 批量改价，数量
        EditSome({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                editSome(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 货道变动历史
        GetHistoryList({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                getHistoryList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 物品列表
        ProductIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                productIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 物品编辑获取详情
        GetProductDetail({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                getProductDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 物品原料详情
        GetProductMaterialDetail({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                getProductMaterialDetail(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
             // 获取所有商品
        AllProductAndCategory({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                allProductAndCategory(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        ItemCodeIndex({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                itemCodeIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        ItemCodeSave({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                itemCodeSave(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        ItemCodeImport({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                itemCodeImport(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        ItemCodeFreeze({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                itemCodeFreeze(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        ItemCodeTrace({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                itemCodeTrace(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        ItemCodeEvents({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                itemCodeEvents(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存物品编辑
        SaveProduct({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                saveProduct(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存商品指导价并同步到使用该商品的有效货道
        SyncProductRoadPrice({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                syncProductRoadPrice(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
         //导入物品
         SaveProductDaoRu({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                saveProductDaoRu(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
            },
        // 导出物品
        DaoProduct({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                daoProduct(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除物品列表
        DelProduct({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                delProduct(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 物品分类列表
        ProductCategoryIndex({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                productCategoryIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
          // 物品分类列表productCategoryOid
          ProductCategoryOid({
            commit,
            state
            }, date) {
            return new Promise((resolve, reject) => {
                productCategoryOid(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        AllCategoryName({
                            commit,
                            state
                        }) {
            return new Promise((resolve, reject) => {
                allCategoryName().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        //根据ID获取商品RFID明细
        GetProductRfidDetail({
            commit,
            state
        }, date) {
                return new Promise((resolve, reject) => {
                    getProductRfidDetail(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
        //根据ID删除商品RFID数据
        ProductRfidDel({
            commit,
            state
        }, date) {
                return new Promise((resolve, reject) => {
                    productRfidDel(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
        // 编辑分类
        GetCategoryDetail({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getCategoryDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存编辑
        SaveCategory({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                saveCategory(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除分类
        DelCategory({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                delCategory(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        Uppic({
                  commit,
                  state
              }, date) {
            return new Promise((resolve, reject) => {
                uppic(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 品牌列表
        BrandIndex({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                brandIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取所有品牌
        AllBrandName({
                         commit,
                         state
                     }) {
            return new Promise((resolve, reject) => {
                allBrandName().then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 编辑品牌 获取详情
        GetBrandDetail({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                getBrandDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存编辑/新录
        SaveBrand({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                saveBrand(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除品牌
        DelBrand({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                delBrand(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 今日缺货清单列表
        ReplenishmentIndex({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                replenishmentIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查看出库单
        OutboundOrder({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                outboundOrder(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查看缺货清单
        ReplenishmentNote({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                replenishmentNote(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 更新缺货清单
        UpdateReplenishment({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                updateReplenishment(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 打印出库单汇总
        GetOutall({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                getOutall(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 补货历史
        HistoryIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                historyIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 订单列表
        OrderIndex({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                orderIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 盲盒订单列表
        GetBlinkboxOrderList({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                getBlinkboxOrderList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 盲盒订单列表
        SaveBlinkboxOrderWithdrawal({
                                        commit,
                                        state
                                    }, date) {
            return new Promise((resolve, reject) => {
                saveBlinkboxOrderWithdrawal(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 盲盒提现订单列表
        GetBlinkboxOrderWithdrawalList({
                                           commit,
                                           state
                                       }, date) {
            return new Promise((resolve, reject) => {
                getBlinkboxOrderWithdrawalList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 查看订单时间日志
        OrderLog({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                orderLog(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 退款
        GetRefundDetail({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                getRefundDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetAdminUsers({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                getAdminUsers(date).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error)
            })
            })
            },
        // 导出用户售货机订单
        ExportOrder({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                exportOrder(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 退款列表
        RefundIndex({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                refundIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出退款列表
        DaoRefund({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                daoRefund(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 确定退款
        SaveRefund({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                saveRefund(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // //取消/确认收货/发货订单
        OperationOrderFormMaterial({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                operationOrderFormMaterial(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
            },
        // 终止工单
        OrderReceiveEnd({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                orderReceiveEnd(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
            },
        // 终止格子订单
        OrderBoxEnd({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                orderBoxEnd(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 终止订单
        OrderEnd({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                orderEnd(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 每台机器销售金额
        MachineSalesAmountIndex({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                machineSalesAmountIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查看每台机器销售金额信息
        GetSalesDetails({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                getSalesDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出每台机器销售金额信息
        DaoMachineSalesAmountIndex({
                                       commit,
                                       state
                                   }, date) {
            return new Promise((resolve, reject) => {
                daoMachineSalesAmountIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 签约列表
        SignupIndex({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                signupIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取签约详情
        GetSignupDetail({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                getSignupDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出数据
        DaoSignup({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                daoSignup(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 合同结算列表
        ContractIndex({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                contractIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查看每日每台数据
        GetDataPerMachine({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getDataPerMachine(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取每日机器信息
        GetDailyData({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                getDailyData(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出数据
        DaoContract({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                daoContract(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 仓库列表
        ArehouseIndex({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                arehouseIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 编辑仓库
        GetArehouseDetail({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getArehouseDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存编辑
        SaveArehouse({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                saveArehouse(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除仓库
        DelArehouse({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                delArehouse(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 库存列表
        StockIndex({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                stockIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 编辑库存
        GetStockDetail({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                getStockDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存库存编辑
        SaveStock({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                saveStock(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除库存
        DelStock({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                delStock(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 数量变动列表
        NumChangIndex({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                numChangIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 入库详情
        GetOutStockDetail({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getOutStockDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存入库详情
        SaveOutStock({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                saveOutStock(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 搜索扫码登记
        GetBarDetail({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                getBarDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 出库登记列表
        OutStockIndex({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                outStockIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 货道模板删除
        delRoadTemplateDetail({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                delRoadTemplateDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 广告列表
        AdIndex({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                adIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 编辑广告获取详情
        GetAdDetail({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                getAdDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取视频上传的uptoken
        Uptoken({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                uptoken(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 上传文件
        UploadFiles({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                uploadFiles(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存头像
        SaveHearImg({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                saveHearImg(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 保存新录广告
        SaveAd({
                   commit,
                   state
               }, date) {
            return new Promise((resolve, reject) => {
                saveAd(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除广告
        DelAd({
                  commit,
                  state
              }, date) {
            return new Promise((resolve, reject) => {
                delAd(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存广告推送
        PushAd({
                   commit,
                   state
               }, date) {
            return new Promise((resolve, reject) => {
                pushAd(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 推送列表
        Machinesjqcode({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                machinesjqcode(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        AdpMacIndex({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                adpMacIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        WxxcxIndex({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                wxxcxIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SetMealIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                setMealIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        CouponIndex({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                couponIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        CouponIssuanceIndex({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                couponIssuanceIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        PayeeIndex({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                payeeIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        GetPayCodeProductList({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                getPayCodeProductList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        PayCodeIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                payCodeIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        PayeeOIndex({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                payeeOIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        VersionIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                versionIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        WxIndex({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                wxIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 广告播放计划列表
        ReplenishmentTotal({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                replenishmentTotal(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 广告播放计划列表
        GetAdPlanList({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                getAdPlanList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 广告投放
        MachineAdvertisementIndex({
                                      commit,
                                      state
                                  }, date) {
            return new Promise((resolve, reject) => {
                machineAdvertisementIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查看广告投放
        ChaMachineAdvertisement({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                chaMachineAdvertisement(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 货道模板~查看和编辑的接口
        getRoadTemplateDetail({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                getRoadTemplateDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        //货道模板列表
        roadTemplateIndex({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                roadTemplateIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 保存编辑广告投放
        SaveMachineAdvertisement({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                saveMachineAdvertisement(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 批量删除
        DelMachineAdvertisement({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                delMachineAdvertisement(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 批量上下架
        MachineAdvertisingStatus({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                machineAdvertisingStatus(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 改变上下架状态
        UpdateStatus({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                updateStatus(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 下架物品列表
        UpdataStatus({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                updataStatus(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 组织管理树形图
        OrganizationIndex({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                organizationIndex(date).then(data => {
                    commit('SET_ORGANI_ID', data.data[0].id);
                    commit('SET_ORGANNAME', data.data[0].name);
                    commit('SET_INSTITUT', data.data);
                    commit('SET_ROLE', data.role);
                    commit('SET_NO_ROLE', data.no_role);
                    commit('SET_PARENTID', data.data[0].parentid);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 机构用户表格
        OrganizationNameIndex({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                organizationNameIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取一个机构的全部物品
        GetAllProductIndex({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                getAllProductIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
          // 获取一个机构的全部物品
          GetProductBymoid({
               commit,
               state
            }, date) {
            return new Promise((resolve, reject) => {
                getProductBymoid(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
         // 获取一个机构的全部物品新
         GetAllProductIndexNew({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                getAllProductIndexNew(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取组织的机台供商品选择
        GetProductLathe({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                getProductLathe(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
         // 工单点击商品日志
         GetOrderLog({
            commit,
            state
          }, date) {
            return new Promise((resolve, reject) => {
                getOrderLog(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        // 获取一个机构的全部物品新
        DaoruOrderReceive({
            commit,
            state
          }, date) {
                return new Promise((resolve, reject) => {
                daoruOrderReceive(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
        // 获取一个分类的物品
        GetAllProductCid({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                getAllProductCid(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 新录领用点
        AddOrganization({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                addOrganization(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取机构详情
        GetOrganizationDetail({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                getOrganizationDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存编辑机构
        SaveOrganization({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                saveOrganization(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除机构
        DelOrganization({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                delOrganization(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 新录机构
        AddOrganizationUser({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                addOrganizationUser(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查询导入机构
        CheckMesOrganizationUser({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                checkMesOrganizationUser(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        CheckProduct({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                checkProduct(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 查询导入商品
        CheckMesProduct({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                checkMesProduct(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 新录用户获取权限
        GetAddAdminAuth({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                getAddAdminAuth(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 当前用户获取权限
        GetAdminRoleList({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                getAdminRoleList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 编辑机构用户获取详情
        GetOrganizationUserDetail({
                                      commit,
                                      state
                                  }, date) {
            return new Promise((resolve, reject) => {
                getOrganizationUserDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存编辑
        SaveOrganizationUser({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                saveOrganizationUser(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除机构用户
        DelOrganizationUser({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                delOrganizationUser(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
         // 录入是由
         Inputbyfirm({
            commit,
            state
            }, date) {
                return new Promise((resolve, reject) => {
                    inputbyfirm(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
                // 录入是由
            Inputbyupdatedel({
            commit,
            state
            }, date) {
                return new Promise((resolve, reject) => {
                    inputbyupdatedel(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
                GetAdminByOrder({
                    commit,
                    state
                    }, date) {
                        return new Promise((resolve, reject) => {
                            getAdminByOrder(date).then(data => {
                        resolve(data);
                        }).catch(error => {
                        reject(error)
                        })
                        })
                        },
                        ZhipaiOrder({
                            commit,
                            state
                            }, date) {
                                return new Promise((resolve, reject) => {
                                    zhipaiOrder(date).then(data => {
                                resolve(data);
                                }).catch(error => {
                                reject(error)
                                })
                                })
                                },
                         // 录入是由
                Getinputby({
                commit,
                state
                }, date) {
                    return new Promise((resolve, reject) => {
                        getinputby(date).then(data => {
                    resolve(data);
                    }).catch(error => {
                    reject(error)
                    })
                    })
                    },

        // 物品机库列表
        CommodityBaseIndex({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                commodityBaseIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 新录物品列表
        GetCommodityBaseDetail({
                                   commit,
                                   state
                               }, date) {
            return new Promise((resolve, reject) => {
                getCommodityBaseDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存新录
        AddCommodityBase({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                addCommodityBase(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 修改机器状态
        UpdateMachinesStatus({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                updateMachinesStatus(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 远程锁机设置
        SetLockStatus({ commit }, date) {
            return new Promise((resolve, reject) => {
                setLockStatus(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        // 给机器授权组织
        MachineLicensingOrganization({
                                         commit,
                                         state
                                     }, date) {
            return new Promise((resolve, reject) => {
                machineLicensingOrganization(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 授权人员
        GetMachineLicensingUser({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                getMachineLicensingUser(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 确定授权人员
        MachineLicensingUser({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                machineLicensingUser(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 复制货道物品
        GetRoadMachines({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                getRoadMachines(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存复制货道
        CopyWay({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                copyWay(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 机器详情页
        MachinesDetail({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                machinesDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 修改机器详情
        SaveMachinesDetail({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                saveMachinesDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 修改机器详情
        SaveSubscribeWxGzh({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                saveSubscribeWxGzh(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SavePortionUsers({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                savePortionUsers(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 修改机器详情
        GetSubscribeWxGzhList({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                getSubscribeWxGzhList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        GetIncenseQrConfig({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                getIncenseQrConfig(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        SaveIncenseQrConfig({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                saveIncenseQrConfig(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 开门
        OpenDor({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                openDor(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 重启机器
        RestartApp({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                restartApp(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 要求机器上传日志
        GetLog({
                   commit,
                   state
               }, date) {
            return new Promise((resolve, reject) => {
                getLog(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        MachineLogRequest({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                machineLogRequest(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        MachineLogList({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                machineLogList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        MachineLogDownload({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                machineLogDownload(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        MachineRestartList(_, date) {
            return machineRestartList(date)
        },
        ClearMac({
            commit,
            state
        }, date) {
     return new Promise((resolve, reject) => {
        clearMac(date).then(data => {
             resolve(data);
         }).catch(error => {
             reject(error)
         })
     })
 },
        
        // 修改物品
        MachinesRoadIndex({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                machinesRoadIndex(date).then(data => {
                    persistReplenisherStockOnly(commit, data.replenisher_stock_only);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        
        // 获取领料单列表
        OrderReceiveIndex({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                orderReceiveIndex(date).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error)
            })
            })
            },
             // 取机器用户列表
             Getusers({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                getusers(date).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error)
            })
            })
            },
        // 工单领用记录
        orderReceiveGoodsIndex({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                orderReceiveGoodsIndex(date).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error)
            })
            })
            },
        // 获取格子订单列表
        OrderBoxIndex({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                orderBoxIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取重力柜称重会话
        BoxWeightSessionIndex({
                                  commit,
                                  state
                              }, date) {
            return new Promise((resolve, reject) => {
                boxWeightSessionIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 复核重力柜异常会话
        BoxWeightSessionReview({
                                   commit,
                                   state
                               }, date) {
            return new Promise((resolve, reject) => {
                boxWeightSessionReview(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取格子订单列表
        DaoGrantUserStatements({
                                   commit,
                                   state
                               }, date) {
            return new Promise((resolve, reject) => {
                daoGrantUserStatements(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 机台超量告警
         Productalertlog({
            commit,
            state
          }, date) {
            return new Promise((resolve, reject) => {
                productalertlog(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        // 机台超量告警阅读
           ProductAlertLogread({
            commit,
            state
          }, date) {
            return new Promise((resolve, reject) => {
                productAlertLogread(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        // 机台超量告警插入
        ProductAlertLogInsert({
            commit,
            state
          }, date) {
            return new Promise((resolve, reject) => {
                productAlertLogInsert(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
          // 机台用料统计
        Mac_materialsIndex({
            commit,
            state
          }, date) {
            return new Promise((resolve, reject) => {
                mac_materialsIndex(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        // 获取格子订单列表
        GrantUserStatementsIndex({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                grantUserStatementsIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
         // 商品销售统计
         SalesStatistics({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                salesStatistics(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
             // 商品销售统计(按机器)
             SalesStatisticsbymac({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                salesStatisticsbymac(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        BorrowStatementsIndex({
            commit,
            state
        }, date) {
return new Promise((resolve, reject) => {
    borrowStatementsIndex(date).then(data => {
resolve(data);
}).catch(error => {
reject(error)
})
})
},
        GrantUserStatementsTotalIndex({
                                          commit,
                                          state
                                      }, date) {
            return new Promise((resolve, reject) => {
                grantUserStatementsTotalIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        OneUserSalesRanking({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                oneUserSalesRanking(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 个人借用排名
        OneUserBorrowRanking({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                oneUserBorrowRanking(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 物品借用量排名
        ProductBorrowRanking({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                productBorrowRanking(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        GrantMacStatementsIndex({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                grantMacStatementsIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        /** mac_statistics 页：无时初/期末，走精简接口 */
        GrantMacStatementsIndexLite({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                grantMacStatementsIndexLite(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取格子列表
        GetBoxList({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                getBoxList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetBoxPackage(_, date) {
            return getBoxPackage(date);
        },
        SaveBoxPackage(_, date) {
            return saveBoxPackage(date);
        },
        SaveWholeTakeBox(_, date) {
            return saveWholeTakeBox(date);
        },
        DisableBoxPackage(_, date) {
            return disableBoxPackage(date);
        },
        PrepareBoxPackagePacking(_, date) {
            return prepareBoxPackagePacking(date);
        },
        OpenBoxPackagePacking(_, date) {
            return openBoxPackagePacking(date);
        },
        ResolveBoxPackagePackingDoor(_, date) {
            return resolveBoxPackagePackingDoor(date);
        },
        CommitBoxPackagePacking(_, date) {
            return commitBoxPackagePacking(date);
        },
        CancelBoxPackagePacking(_, date) {
            return cancelBoxPackagePacking(date);
        },
        GetBoxPackagePackingRecords(_, date) {
            return getBoxPackagePackingRecords(date);
        },
        HandleBoxPackageItem(_, date) {
            return handleBoxPackageItem(date);
        },
        GetWholeTakePartialReturnSetting(_, date) {
            return wholeTakePartialReturnSetting(date);
        },
        SaveWholeTakePartialReturnSetting(_, date) {
            return saveWholeTakePartialReturnSetting(date);
        },
        //设置货道使用人
        setRoadUsers({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                setRoadUsers(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取待审核回收格列表
        GetRetrunBoxList({ commit, state }, date) {
            return new Promise((resolve, reject) => {
                getRetrunBoxList(date).then(data => {
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取待审核回收明细
        GetRetrunBoxDetail({ commit, state }, date) {
            return new Promise((resolve, reject) => {
                getRetrunBoxDetail(date).then(data => {
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 保存回收审核
        SaveReturnExamine({ commit, state }, date) {
            return new Promise((resolve, reject) => {
                saveReturnExamine(date).then(data => {
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取格子列表
        SaveBox({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                saveBox(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
                // 开格子
        ToOpenBox({
                    commit,
                    state
                }, date) {
            return new Promise((resolve, reject) => {
                toOpenBox(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 合并货道
        mergingFreightLanes({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                mergingFreightLanes(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 确定合并
        FullAllRoad({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                fullAllRoad(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 确定合并
        querenMergingFreightLanes({
                                      commit,
                                      state
                                  }, date) {
            return new Promise((resolve, reject) => {
                querenMergingFreightLanes(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取货道详情
        GetUpdateRoadDetail({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                getUpdateRoadDetail(date).then(data => {
                    persistReplenisherStockOnly(commit, data.replenisher_stock_only);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 批量修改货道物品
        SaveAllRoad({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                saveAllRoad(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetAllUpdateRoadDetail({
                                   commit,
                                   state
                               }, date) {
            return new Promise((resolve, reject) => {
                getAllUpdateRoadDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 修改价格列表
        GetMachinesProductIndex({
                                    commit,
                                    state
                                }, date) {
            return new Promise((resolve, reject) => {
                getMachinesProductIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetMachinesProductDetail({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                getMachinesProductDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 保存修改价格
        SaveMachinesProductDetail({
                                      commit,
                                      state
                                  }, date) {
            return new Promise((resolve, reject) => {
                saveMachinesProductDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 单个修改货道开关
        UpdateRoadStatus({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                updateRoadStatus(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 关闭/开启整层
        UpdateAllRoadStatus({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                updateAllRoadStatus(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 缺货清单
        ChaReplenishmentNote({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                chaReplenishmentNote(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
         // 缺货清单
         ChaReplenishmentNoteNew({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
            chaReplenishmentNoteNew(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        // 更改货道类型
        GetMacsRoadDetail({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                getMacsRoadDetail(date).then(data => {
                    commit("SET_LEMENTS", data.machines_road);
                    commit("SET_MACHINAME", data.machines_name);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        PreviewBoxStockTransition(_, date) {
            return previewBoxStockTransition(date);
        },
        CommitBoxStockTransition(_, date) {
            return commitBoxStockTransition(date);
        },
        PreviewProductDeletion(_, date) {
            return previewProductDeletion(date);
        },
        CommitProductDeletion(_, date) {
            return commitProductDeletion(date);
        },
        // 修改货道保存编辑
        SaveMachinesRoad({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                saveMachinesRoad(date).then(data => {
                    commit("SET_LEMENTS", data.machines_road);
                    commit("SET_MACHINAME", data.machines_name);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveMachinesNopush(ctx, date) {
            return new Promise((resolve, reject) => {
                saveMachinesNopush(date)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        SaveMachinesBox({
                            commit,
                            state
                        }, date) {
            return new Promise((resolve, reject) => {
                saveMachinesBox(date).then(data => {
                    commit("SET_LEMENTS", data.machines_road);
                    commit("SET_MACHINAME", data.machines_name);
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 问题列表
        ProblemIndex({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                problemIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 新录问题
        SaveProblem({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                saveProblem(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetProblemDetail({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                getProblemDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        DelProblem({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                delProblem(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 新录故障
        SaveTroubleShooting({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                saveTroubleShooting(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
            //订货订单列表
            OrderFormMaterialList({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                orderFormMaterialList(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
            //订货订单详情
            GetOrderFormMaterialDetail({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                getOrderFormMaterialDetail(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
        // 分账接收方列表
         SeparateAccountList({
                    commit,
                    state
                }, date) {
                 return new Promise((resolve, reject) => {
                        separateAccountList(date).then(data => {
                    resolve(data);
                    }).catch(error => {
                    reject(error)
                    })
                    })
         },
         // 会员列表
         GetXcxUserList({
            commit,
            state
        }, date) {
         return new Promise((resolve, reject) => {
            getXcxUserList(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
 },
          // 保存编辑分账接收方
          SaveSeparateAccount({
            commit,
            state
        }, date) {
         return new Promise((resolve, reject) => {
            saveSeparateAccount(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
        },
        //大屏幕
        GetDaPingList({
            commit,
            state
        }, date) {
         return new Promise((resolve, reject) => {
            getDaPingList(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
        },
         // 根据ID删除分账接收方数据
         SeparateAccountDel({
            commit,
            state
        }, date) {
         return new Promise((resolve, reject) => {
            separateAccountDel(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
        },
        // 根据ID查询分账接收方数据
        GetSeparateAccountDetail({
            commit,
            state
        }, date) {
         return new Promise((resolve, reject) => {
            getSeparateAccountDetail(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
        },
            // 获取全部分账接收方列表
            SeparateAccountLists({
                commit,
                state
            }, date) {
             return new Promise((resolve, reject) => {
                separateAccountLists(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
            // 分账配置列表
        SeparateSettingList({
                commit,
                state
                }, date) {
                return new Promise((resolve, reject) => {
                   separateSettingList(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
            // 商品RFID列表
        ProductRfidList({
            commit,
            state
            }, date) {
            return new Promise((resolve, reject) => {
              productRfidList(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
        },
        // 保存商品RFID
        SaveProductRfid({
           commit,
           state
           }, date) {
           return new Promise((resolve, reject) => {
            saveProductRfid(date).then(data => {
           resolve(data);
           }).catch(error => {
            reject(error)
           })
          })
            },
            // 保存编辑分账配置
            SaveSeparateSetting({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                saveSeparateSetting(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
            // 根据ID删除分账配置数据
            SeparateSettingDel({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                separateSettingDel(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
             // 根据ID更改分账配置启用禁用
             ChangeseparateSettingState({
                commit,
                state
            }, date) {
                return new Promise((resolve, reject) => {
                    changeseparateSettingState(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
            // 根据ID查询分账配置数据
            GetSeparateSettingDetail({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                getSeparateSettingDetail(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
            // 分账记录列表
            SeparateDetailsList({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                    separateDetailsList(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
              // 分账验证列表
            SeparateVerifyList({
                commit,
                state
            }, date) {
            return new Promise((resolve, reject) => {
                separateVerifyList(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
            },
            // 根据ID查询分账记录数据
            GetSeparateDetailsDetail({
            commit,
            state
            }, date) {
            return new Promise((resolve, reject) => {
            getSeparateDetailsDetail(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
           // 新录原料
           SaveMaterial({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                saveMaterial(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
            // 新录原料分类
     SaveMaterialCategory({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                saveMaterialCategory(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        TroubleShootingIndex({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                troubleShootingIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        Material({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                material(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
            //fenlei 
            MaterialCategory({
                commit,
                state
            }, date) {
                return new Promise((resolve, reject) => {
                    materialCategory(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
            GetCategoryLists({
                commit,
                state
            }, date) {
    return new Promise((resolve, reject) => {
        getCategoryLists(date).then(data => {
    resolve(data);
    }).catch(error => {
    reject(error)
    })
    })
    },
        GetTroubleShootingDetail({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                getTroubleShootingDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 根据id查原料数据
        GetMaterialDetail({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                getMaterialDetail(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
            // 根据条件查原料数据
            GetMaterialLists({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                getMaterialLists(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
             // 根据id删除原料数据
            MaterialDel({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                materialDel(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
              // 根据id更改原料上下架
              ChangeMaterialState({
                commit,
                state
            }, date) {
                return new Promise((resolve, reject) => {
                    changeMaterialState(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
              // 根据id删除原料分类数据
            MaterialCategoryDel({
                commit,
                state
            }, date) {
                return new Promise((resolve, reject) => {
                    materialCategoryDel(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
                SaveMaterialTaste({
                    commit,
                    state
                }, date) {
                    return new Promise((resolve, reject) => {
                        saveMaterialTaste(date).then(data => {
                    resolve(data);
                    }).catch(error => {
                    reject(error)
                    })
                    })
                    },
           //充值
            Recharge({
                commit,
                state
            }, date) {
                return new Promise((resolve, reject) => {
                    recharge(date).then(data => {
                resolve(data);
                }).catch(error => {
                reject(error)
                })
                })
                },
             // 根据id查原料分类数据
        GetMaterialCategoryDetail({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                getMaterialCategoryDetail(date).then(data => {
            resolve(data);
            }).catch(error => {
            reject(error)
            })
            })
            },
        // 查看故障详情
        CheckFault({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                checkFault(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        HandleTrouble({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                handleTrouble(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出订单
        DaoOrder({
                     commit,
                     state
                 }, date) {
            return new Promise((resolve, reject) => {
                daoOrder(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出导出智能柜订单列表
        daoOrderEmergency({
                              commit,
                              state
                          }, date) {
            return new Promise((resolve, reject) => {
                daoOrderEmergency(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 经营报表
        OperatingStatementsIndex({
                                     commit,
                                     state
                                 }, date) {
            return new Promise((resolve, reject) => {
                operatingStatementsIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        MachinesDayTurnover({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                machinesDayTurnover(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 按月导出
        MachinesMonth({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                machinesMonth(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 按天导出
        MachinesDay({
                        commit,
                        state
                    }, date) {
            return new Promise((resolve, reject) => {
                MachinesDay(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 补货记录
        RecordDuring({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                RecordDuring(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 补货详情
        RecordDuringDetails({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                RecordDuringDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 温控设置
        RunSetting({
                       commit,
                       state
                   }, date) {
            return new Promise((resolve, reject) => {
                runSetting(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        AllWarehouses({
                          commit,
                          state
                      }, date) {
            return new Promise((resolve, reject) => {
                allWarehouses(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetAllProductNames({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                getAllProductNames(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 取货码订单列表
        PickupOrderIndex({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                pickupOrderIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveLathe({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                saveLathe(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveWs({
                   commit,
                   state
               }, date) {
            return new Promise((resolve, reject) => {
                saveWs(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SaveUserGroup({
                   commit,
                   state
               }, date) {
            return new Promise((resolve, reject) => {
                saveUserGroup(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        
        // AddLathe({
        //              commit,
        //              state
        //          }, date) {
        //     return new Promise((resolve, reject) => {
        //         addLathe(date).then(data => {
        //             resolve(data);
        //         }).catch(error => {
        //             reject(error)
        //         })
        //     })
        // },
        GetLatheList({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                getLatheList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetWsList({
                      commit,
                      state
                  }, date) {
            return new Promise((resolve, reject) => {
                getWsList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        
        GetUserGroupList({
            commit,
            state
        }, date) {
  return new Promise((resolve, reject) => {
      getUserGroupList(date).then(data => {
          resolve(data);
      }).catch(error => {
          reject(error)
      })
  })
},
        GetVisibleUserGroupList({
            commit,
            state
        }, date) {
  return new Promise((resolve, reject) => {
      getVisibleUserGroupList(date).then(data => {
          resolve(data);
      }).catch(error => {
          reject(error)
      })
  })
},
        MoveOrganization({
                             commit,
                             state
                         }, date) {
            return new Promise((resolve, reject) => {
                moveOrganization(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 导出数据
        DaopickupOrder({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                daopickupOrder(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 订单详情
        PickupOrderDetails({
                               commit,
                               state
                           }, date) {
            return new Promise((resolve, reject) => {
                pickupOrderDetails(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 用户列表
        DrugUsersIndex({
                           commit,
                           state
                       }, date) {
            return new Promise((resolve, reject) => {
                drugUsersIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 导出用户列表
        DaoDrugUsers({
                         commit,
                         state
                     }, date) {
            return new Promise((resolve, reject) => {
                daoDrugUsers(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 智能柜订单
        orderEmergencyIndex({
                                commit,
                                state
                            }, date) {
            return new Promise((resolve, reject) => {
                orderEmergencyIndex(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 存储列表
        StorageList({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                storageList(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 切换存储状态
        StorageChange({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                storageChange(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 存储设置信息
        StorageSetup({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                storageSetup(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 存储设置信息
        SetupSave({
            commit,
            state
        }, date) {
            return new Promise((resolve, reject) => {
                setupSave(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 智能柜订单详情
        orderEmergencyDetail({
                                 commit,
                                 state
                             }, date) {
            return new Promise((resolve, reject) => {
                orderEmergencyDetail(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        Setids({
                   commit
               }, machinesname) {
            commit('SET_machinesname', machinesname);
        },
        Setjiqicode({
                        commit
                    }, jiqicode) {
            commit('SET_jiqicode', jiqicode);
        },
        Setcreate_time({
                           commit
                       }, create_time) {
            commit('SET_create_time', create_time);
        },
        Setnums({
                    commit
                }, nums) {
            commit('SET_nums', nums);
        },
        // 清空用户脸部信息
        ClearFaceData({ commit, state }, date) {
            return new Promise((resolve, reject) => {
                clearFaceData(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        // 清空用户卡片信息
        ClearCardData({ commit, state }, date) {
            return new Promise((resolve, reject) => {
                clearCardData(date).then(data => {
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            })
        },
    }
}
export default table
